import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/pcs_provider_setting_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
// enum/subject/predicate/value inherited from EnumSettingResource.
const PcsProviderSettingSchema = withDefaults({
  type: 'pcs-provider-setting',
  fields: [
    { kind: 'attribute', name: 'enum' },
    { kind: 'attribute', name: 'subject' },
    { kind: 'attribute', name: 'predicate' },
    { kind: 'attribute', name: 'value' },
    {
      kind: 'belongsTo',
      name: 'pcsProvider',
      type: 'pcs-provider',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsProviderSettingSchema;
